import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 13.5913 17.3679 15.1174 16.2426 16.2426C15.1174 17.3679 13.5913 18 12 18Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Dot05Xl"
);
